<ng-container *transloco="let t; read: 'user'">
<div class="flex flex-row p-5">
  <h1 class="userProfile font-semibold">{{ t('userProfile.edit.pageTitle') }}</h1>
</div>
<div class="place-content-center mr-5 ml-2">
  <drdp-container>
    <div class="
        lg:flex
        place-content-between place-items-center
        border-b border-drdpgrey-100
        self-center
        hidden
      ">
      <h1 class="information font-semibold mt-1">{{ t('userProfile.edit.detailsTitle') }}</h1>
    </div>
    <div class=""></div>
    <div class="w-full">
      <!-- ! Form Begins ! -->
      <div>
        <form [formGroup]="editUserForm">
          <div class="pt-4">
            <div class="grid grid-cols-3 gap-8">
              <div>
                <label for="firstName">{{ t('userProfile.edit.workEmail') }}<span class="required"></span></label>
                <mat-form-field class="bg-white w-full" appearance="fill">
                  <input matInput type="text" maxlength="100" formControlName="emailName" required />
                </mat-form-field>
                @if (emailName.invalid && emailName.touched) {
                  <span class="required">{{ t('userProfile.edit.emailRequired') }}</span>
                }
              </div>

              <div>
                <label></label>
                <input class="blank" matInput type="text" maxlength="1" />
              </div>

              <div>
                <label></label>
                <input class="blank" matInput type="text" maxlength="1" />
              </div>
              <div>
                <label for="firstName">{{ t('userProfile.edit.firstName') }}<span class="required"></span></label>
                <mat-form-field class="bg-white w-full" appearance="fill">
                  <input matInput type="text" maxlength="50" formControlName="firstName" required />
                </mat-form-field>
                @if (firstName.invalid && firstName.touched) {
                  <span class="required">{{ t('userProfile.edit.firstNameRequired') }}</span>
                }
              </div>

              <div>
                <label>{{ t('userProfile.edit.middleInitial') }}</label>
                <mat-form-field class="bg-white w-full" appearance="fill">
                  <input matInput type="text" maxlength="1" formControlName="middleName" />
                </mat-form-field>
              </div>

              <div>
                <label>{{ t('userProfile.edit.lastName') }}<span class="required"></span></label>
                <mat-form-field class="bg-white w-full" appearance="fill">
                  <input matInput type="text" maxlength="50" formControlName="lastName" required />
                </mat-form-field>
                @if (lastName.invalid && lastName.touched) {
                  <span class="required">{{ t('userProfile.edit.lastNameRequired') }}</span>
                }
              </div>
              <div>
                <drdp-select-suffix [initialSuffix]="suffix.value" (suffix)="handleSuffix($event)">
                </drdp-select-suffix>
              </div>
              <div>
                <label>{{ t('userProfile.edit.workTitle') }}</label>
                <mat-form-field class="bg-white w-full mt-2" appearance="fill">
                  <input matInput type="text" maxlength="50" formControlName="jobTitle"/>
                </mat-form-field>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-8 mt-6">
              <div>
                <label>{{ t('userProfile.edit.completedTrainings') }}<span class="required"></span></label>
                <div class="flex flex-col mt-2">
                  @for (training of trainings; track training.id) {
                    <mat-checkbox color="primary"
                      [checked]="isTrainingSelected(training.id)"
                      (change)="handleTraining($event, training.id)">
                      <!-- Server-supplied training name. -->
                      {{ training.trainingName }}
                    </mat-checkbox>
                  }
                </div>
                @if (trainingIds.invalid && trainingIds.touched) {
                  <span class="required">{{ t('userProfile.edit.fieldRequired') }}</span>
                }
              </div>

              <div>
                <drdp-radio-yes-no [label]="t('userProfile.edit.cecoCertifiedQuestion')" [required]="true"
                  formControlName="isCecoCertified">
                </drdp-radio-yes-no>
                @if (isCecoCertified.invalid && isCecoCertified.touched) {
                  <span class="required">{{ t('userProfile.edit.fieldRequired') }}</span>
                }
              </div>
            </div>

            @if (canEditUserProfileAgencyData) {
              <div class="grid grid-cols-2 gap-8 mt-6">
                <div>
                  <drdp-radio-yes-no [label]="t('userProfile.edit.agencyRatingViewsLockedQuestion')" [required]="true"
                    formControlName="isAgencyRatingViewLocked">
                  </drdp-radio-yes-no>
                  @if (isAgencyRatingViewLocked.invalid && isAgencyRatingViewLocked.touched) {
                    <span class="required">{{ t('userProfile.edit.fieldRequired') }}</span>
                  }
                </div>

                <div>
                  <drdp-radio-yes-no [label]="t('userProfile.edit.agencyEulaSubmittedQuestion')" [required]="true"
                    formControlName="isAgencyEulaSubmitted">
                  </drdp-radio-yes-no>
                  @if (isAgencyEulaSubmitted.invalid && isAgencyEulaSubmitted.touched) {
                    <span class="required">{{ t('userProfile.edit.fieldRequired') }}</span>
                  }
                </div>
              </div>
            }
          </div>
        </form>
      </div>
      <div class="flex flex-row-reverse">
        <!-- Validators are 8 characters min, All inputs required and passwords have to match -->
        <drdp-btn type="submit" (click)="onSubmit()">{{ t('userProfile.edit.save') }}</drdp-btn>

        <drdp-btn color="cancel" class="mr-6" routerLink="/user-profile">{{ t('userProfile.edit.cancel') }}</drdp-btn>
      </div>
    </div>
  </drdp-container>
</div>
</ng-container>